module.exports = __webpack_public_path__ + "img/4.03.thmb.xs.c68bdabe.jpg";